import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useEffect, useState } from 'react';
export const useIntersectionObserver = reference => {
  const $ = _c(4);
  const [isIntersecting, setIsIntersecting] = useState(false);
  let t0;
  if ($[0] !== reference.current) {
    t0 = () => {
      const element = reference.current;
      if (!element) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        if (entry?.isIntersecting === true) {
          setIsIntersecting(true);
          observer.disconnect();
        }
      });
      observer.observe(element);
      return () => observer.disconnect();
    };
    $[0] = reference.current;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== reference) {
    t1 = [reference];
    $[2] = reference;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
  return isIntersecting;
};